import React, { useState, useCallback, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import Cookies from "js-cookie";
import "../../styles/editfieldmodal.css"; // Include responsive styles
import api from "../../api.js";

const EditFieldModal = ({ show, onClose, field, onUpdate }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
  });
  const [thumbnail, setThumbnail] = useState(null);
  const [loading, setLoading] = useState(false);

  // Set field data when modal opens
  useEffect(() => {
    if (field) {
      setFormData({
        title: field.title || "",
        description: field.description || "",
      });
    }
  }, [field]);

  const onDrop = useCallback((acceptedFiles) => {
    setThumbnail(acceptedFiles[0]);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [],
    },
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    const token = Cookies.get("access_token");
    const updateData = new FormData();

    if (formData.title && formData.title !== field.title)
      updateData.append("title", formData.title);

    if (formData.description && formData.description !== field.description)
      updateData.append("description", formData.description);

    if (thumbnail) updateData.append("thumbnail", thumbnail);

    try {
      const response = await api.patch(
        `/field/${field.id}/`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      onUpdate(response.data);
      onClose();
    } catch (err) {
      console.error("Update failed:", err);
      alert("خطا در بروزرسانی اطلاعات!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>عنوان</Form.Label>
            <Form.Control
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="عنوان را وارد کنید"
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>توضیحات</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="توضیحات حوزه را وارد کنید"
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>تصویر</Form.Label>
            <div {...getRootProps()} className="dropzone-box mt-2">
              <input {...getInputProps()} />
              {isDragActive ? (
                <p className="text-center">فایل را رها کنید...</p>
              ) : (
                <p className="text-center">فایل را بکشید یا برای انتخاب کلیک کنید</p>
              )}
            </div>
            {thumbnail && (
              <p className="mt-2 text-success">فایل انتخاب شده: {thumbnail.name}</p>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-edit" variant="secondary" onClick={onClose}>
          لغو
        </Button>
        <Button className="btn-submit" variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "ذخیره تغییرات"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditFieldModal;
